import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-six-grid")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-six-grid")),
  head: () => ({
    meta: [
      { title: "بلوك ٥ — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
